import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { appState } from "./app/appState";
import AppRouter from "./routes/AppRouter";
import { observer } from "mobx-react-lite";

const App = observer(function App() {
  useEffect(() => {
    // Initialize appState if not already done
    appState.intialize();
  }, []);

  // Theme lives on <html> so portals (popovers rendered into body) resolve the same tokens.
  useEffect(() => {
    document.documentElement.dataset.theme = appState.theme;
    const color = appState.theme === "light" ? "#e5e5e5" : "#262626";
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", color);
  }, [appState.theme]);

  return (
    <>
      {appState.hydrated ? (
        <div className="app-root" data-theme={appState.theme}>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
});

export default App;
